import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Auth';
import Home from './pages/Home';
import Profile from './pages/Profile';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './lib/supabase';
import Avatar from './components/Avatar';

function App() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState<{ id: string, lastname: string, firstname: string, avatar: string } | null>(null);

  useEffect(() => {
    async function getUserProfile() {
      try {
        // Récupérer la session actuelle
        let { data: { session } } = await supabase.auth.getSession();

        if (session && session.user) {
          const profile = sessionStorage.getItem('userProfile');
          if (profile) {
            setProfile(JSON.parse(profile));
          } else {
            navigate('/compte');
          }
        } else {
          navigate('/');
        }
      } catch (err) {
        console.warn('Erreur chargement profil ou rafraîchissement session:', err);
      }
    }
  
    getUserProfile();
  }, [navigate]);

  return (
    <main>
      <nav className="nav">
        <a onClick={() => navigate('/')}>
          <h1 className="logo">Kiké</h1>
        </a>
        
        {profile && 
          <button className="account" onClick={() => navigate('/compte')}>
            <Avatar avatar={profile.avatar}/>
            {profile.firstname} {profile.lastname}
          </button>
        }
      </nav>
      <div className="page">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/compte" element={<Profile />} />
          <Route path="/dispo" element={<Home />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </main>
  );
}

export default App;